import {lazy} from 'react';
 


export const routes = [
    {
        path: "/noservice",
        exact: true,
        component: lazy(() => import("./components/NoService")),
        name: "NoService"
    }
];
